const chart = {
  chartInfo: {
    name: "姓名",
    gender: "性别",
    birthDate: "出生日期",
    solarDate: "阳历日期",
    shengXiao: "生肖",
    fiveElement: "五行",
    lunarDate: "农历日期",
  },
  
  myChart: {
    title: "我的紫微斗数星盘",
    subtitle: "查看您个人的紫微斗数星盘和分析",
    profileDetails: "档案详情",
    keySummary: "关键摘要",
    detailedAnalysis: "详细分析",
    createProfile: "创建您的个人资料",
    createProfileDesc: "要生成您的个人紫微斗数星图，请提供您的出生信息。",
    editProfile: "编辑个人资料",
    career: "事业与财富",
    health: "健康与养生",
    relationships: "人际关系与家庭",
    lifePurpose: "人生目标与精神追求",
    chartVisualization: "星盘可视化",
    createOtherProfile: "为他人创建档案",
    fields: {
      name: "姓名",
      type: "类型",
      birthDate: "出生日期",
      birthTime: "出生时间",
      gender: "性别",
      male: "男",
      female: "女",
      self: "本人",
      other: "他人"
    }
  },
  
  result: {
    loading: "正在加载图表...",
    chart: "命盘",
    subtitle: "紫微斗数命盘分析",
    profileDetails: "个人资料详情",
    chartVisualization: "命盘可视化",
    chartVisualizationPlaceholder: "这是一个占位符可视化。在完整实现中，这里将显示交互式紫微斗数命盘。",
    shareChart: "分享",
    print: "打印",
    exportTitle: "紫微斗数命盘分析",
    generatedOn: "生成于",
    confidential: "机密报告 - 仅供个人使用",
    refreshChart: "刷新图表",
    detailedAnalysis: "详细分析",
    keyInsights: "关键洞察",
    house: "宫",
    scrollToView: "滚动查看整个图表",
    pinchToZoom: "捏合缩放",
    viewportInstructions: "使用缩放控件和滚动查看图表的所有部分",
    fields: {
      relationship: "关系",
      birthPlace: "出生地",
      generated: "生成"
    },
    insights: {
      lifePath: "人生道路",
      lifePathText: "人生道路洞察的占位文本",
      personality: "性格特质",
      personalityText: "性格特质的占位文本",
      fortune: "财富运势",
      fortuneText: "财富预测的占位文本"
    },
    analysis: {
      careerWealth: "事业与财富",
      careerWealthText: "这是事业与财富详细分析的占位文本。在完整实现中，这里会包含关于职业道路、财务前景和财富管理建议的个性化洞察。",
      suitableCareer: "适合的职业",
      suitableCareerText: "技术，金融，研究",
      financialOutlook: "财务前景",
      financialOutlookText: "稳定且具有增长潜力",
      
      relationshipsFamily: "人际关系与家庭",
      relationshipsFamilyText: "这是人际关系与家庭分析的占位文本。在完整实现中，这里会包含关于关系模式、家庭动态和与他人兼容性的个性化洞察。",
      relationshipStyle: "关系风格",
      relationshipStyleText: "忠诚，耐心，善于分析",
      compatibleSigns: "相配的生肖",
      compatibleSignsText: "马，兔，羊",
      
      healthWellness: "健康与养生",
      healthWellnessText: "这是健康与养生分析的占位文本。在完整实现中，这里会包含关于健康倾向、潜在问题和养生建议的个性化洞察。",
      strengths: "优势",
      strengthsText: "强健的免疫系统，充沛的生命能量",
      areasAttention: "需要关注的领域",
      areasAttentionText: "消化系统，压力管理",
      
      lifePurpose: "人生目标与潜能",
      lifePurposeText: "这是人生目标与潜能分析的占位文本。在完整实现中，这里会包含关于人生使命、精神路径和个人成长机会的个性化洞察。",
      naturalTalents: "天赋才能",
      naturalTalentsText: "分析能力，沟通能力，解决问题能力",
      lifeLessons: "人生课题",
      lifeLessonsText: "平衡，情感表达，信任"
    },
    exportPdf: "导出PDF",
    hourAdjustment: {
      title: "调整出生时辰",
      description: "循环浏览12个时辰（地支）以探索命盘变化",
      original: "原始",
      reset: "重置为原始时辰",
      previous: "上一个",
      next: "下一个"
    },
  },
  
  pdfExport: {
    title: "紫微斗数命盘分析",
    subtitle: "专业占星报告",
    profileTitle: "个人资料信息",
    reportGenerated: "报告生成于",
    confidential: "本报告为机密文件，仅供个人使用。",
    chartDescription: "命盘说明",
    chartInfo: "此紫微斗数命盘展示了出生时的天象影响。每个宫位包含特定的星曜，影响生活的不同方面。这些星曜的排列提供了对性格、命运和人生模式的洞察。",
    reportFooter: "报告结束",
    disclaimer: "本报告基于传统中国占星学原理生成。结果应视为指导而非绝对预测。",
    pageNumber: "第",
    exporting: "正在为您准备报告，请稍候...",
    success: "导出完成",
    failed: "导出失败",
    errorMessage: "目前无法完成下载，请稍后再试。",
    successMessage: "您的命盘已准备完成！",
    downloadStarted: "下载将自动开始。",
    processingChart: "请稍候，正在把您的报告整理好...",
    progress: "进度",
    chartName: "命盘",
    step1: "正在汇整您的命盘资料...",
    step2: "正在生成报告封面...",
    step3: "正在排版命盘图像...",
    step4: "正在优化阅读版面...",
    step5: "即将完成下载...",
    starting: "正在为您准备报告，请稍候...",
    serverRendering: "正在把命盘排成清楚、好保存的页面...",
    serverPhase2: "还要一会儿，完整报告内容多时会稍慢，请稍候...",
    serverPhase3: "还在处理。如果同时有好几份报告在导出，你的会按顺序排队。",
    noSession: "请先登录后再下载命盘报告。",
    noData: "没有可导出的命盘数据",
    notSupported: "此浏览器不支持PDF导出",
  },
};

export default chart; 